export const GET_INS_OUTS_REPORT_CSV = 'GET_INS_OUTS_REPORT_CSV';
export const GET_INS_OUTS_REPORT_PDF = 'GET_INS_OUTS_REPORT_PDF';
export const GET_INS_OUTS_REPORT_PAGINATED = 'GET_INS_OUTS_REPORT_PAGINATED';
export const SET_INS_OUTS_REPORT_PAGINATION = 'SET_INS_OUTS_REPORT_PAGINATION';
export const SET_INS_OUTS_REPORT_FILTERS = 'SET_INS_OUTS_REPORT_FILTERS';
export const RESET_INS_OUTS_REPORT = 'RESET_INS_OUTS_REPORT';



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/constants/ins_outs_report_constants.js